export default __webpack_public_path__ + "static/media/burger.55c0625a.jpg";